import React from 'react';
import { Form, Checkbox } from 'antd';

const CommentSettings = () => (
  <>
    {[
      { name: 'submissionCommentsEnabled', label: 'Submission Comments Enabled' },
      { name: 'approvalCommentsMandatory', label: 'Approval Comments Mandatory' },
      { name: 'rejectionCommentsMandatory', label: 'Rejection Comments Mandatory' },
      { name: 'recallCommentsEnabled', label: 'Recall Comments Enabled' },
    ].map((item) => (
      <Form.Item key={item.name} name={item.name} valuePropName="checked">
        <Checkbox>{item.label}</Checkbox>
      </Form.Item>
    ))}
  </>
);

export default CommentSettings;
